// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.AllContractsList-module__emptyList--IBn11 {
    display: flex;
}

.AllContractsList-module__emptyList--IBn11 > p {
    font-size: 14px;
    color: #00000099;
}`, "",{"version":3,"sources":["webpack://./src/widgets/all-contracts-list/AllContractsList.module.css"],"names":[],"mappings":"AAAA;IACI,aAAa;AACjB;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB","sourcesContent":[".emptyList {\r\n    display: flex;\r\n}\r\n\r\n.emptyList > p {\r\n    font-size: 14px;\r\n    color: #00000099;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"emptyList": `AllContractsList-module__emptyList--IBn11`
};
export default ___CSS_LOADER_EXPORT___;
